import React from 'react';
import styles from '../command-palette.scss';
import { ChevronDownIcon, ChevronUpIcon } from '@qualtrics/ui-react/icons';

export const CommandPaletteFooter = () => {
  return (
    <div className={styles.commandPaletteFooter}>
      <div className={styles.footerNavigation}>
        <div className={styles.footerItem}>
          <span className={styles.footerLabel}>Navigate</span>
          <div className={styles.footerKeys}>
            <span className={styles.footerKey}>
              <ChevronDownIcon style={{ width: 12, height: 12 }} aria-hidden />
            </span>
            <span className={styles.footerKey}>
              <ChevronUpIcon style={{ width: 12, height: 12 }} aria-hidden />
            </span>
          </div>
        </div>
        <div className={styles.footerItem}>
          <span className={styles.footerLabel}>Open</span>
          <div className={styles.footerKeys}>
            <span className={styles.footerKey}>↵</span>
          </div>
        </div>
        {/* <div className={styles.footerItem}>
          <span className={styles.footerLabel}>Open in New Tab</span>
          <div className={styles.footerKeys}>
            <span className={styles.footerKey}>⌘</span>
            <span className={styles.footerKey}>↵</span>
          </div>
        </div> */}
      </div>
    </div>
  );
};
